export default __webpack_public_path__ + "static/media/802.d56ddda5.png";